var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEa14B0E966A7A3C4Bd95E270838E6B33(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2143 4.36928C46.5058 4.02283 46.8072 3.67522 47.0987 3.32878C47.3639 3.01563 47.621 2.63297 47.9452 2.39343C48.5025 1.99557 49.2515 2.02826 49.8439 2.09952C51.1724 2.26539 52.4126 2.79405 53.5782 3.37179C55.8648 4.49223 57.9703 5.95618 59.9409 7.55684C62.179 9.37773 64.2606 11.4084 66.039 13.6861C66.8219 14.6915 67.5534 15.7734 68.0757 16.9605C68.4186 17.7358 68.8755 18.8802 68.4088 19.791C68.1558 20.294 67.6552 20.7456 67.2912 21.161C66.6994 21.865 31.1776 63.804 29.2685 66.0626C28.6317 66.8122 27.9862 67.5728 27.3494 68.3224C26.9154 68.8266 26.4708 69.5837 25.8843 69.9044C24.6639 70.5717 22.9866 69.9232 21.9006 69.5073C19.5071 68.5908 17.3157 67.1671 15.2937 65.643C13.0397 63.9448 10.9225 62.0392 9.05883 59.8923C7.69583 58.3208 6.25979 56.5566 5.61476 54.4979C5.42428 53.9061 5.24491 53.1519 5.53232 52.5139C5.73912 52.0465 6.19361 51.6305 6.52134 51.2496C7.87255 49.6407 45.3473 5.38758 46.2143 4.36928Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9453 2.10765C46.1053 1.56272 46.5997 5.25021 51.0246 10.3379C55.4496 15.4256 62.1693 19.9916 65.9993 20.5377C69.8294 21.0838 69.345 17.3951 64.92 12.3074C60.4951 7.21969 53.7754 2.65376 49.9453 2.10765Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.0735,
    y1: 17.2689,
    x2: 48.3229,
    y2: 61.7496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BF6E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 50.6916,
    y1: 5.29457,
    x2: 62.3931,
    y2: 18.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BF6E7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEa14B0E966A7A3C4Bd95E270838E6B33);
export default __webpack_public_path__ + "static/media/ea14b0e966a7a3c4bd95e270838e6b33.94a81460069436a041ee9753c26ae834.svg";
export { ForwardRef as ReactComponent };